"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SessionDataStore = /** @class */ (function () {
    function SessionDataStore() {
    }
    SessionDataStore.prototype.get = function (key) {
        var item = window.sessionStorage.getItem(key);
        if (item !== null) {
            try {
                return JSON.parse(item);
            }
            catch (_a) {
                return null;
            }
        }
        return null;
    };
    SessionDataStore.prototype.set = function (key, value) {
        sessionStorage.setItem(key, JSON.stringify(value));
    };
    SessionDataStore.prototype.remove = function (key) {
        sessionStorage.removeItem(key);
        return true;
    };
    SessionDataStore.prototype.purge = function () {
        sessionStorage.clear();
    };
    return SessionDataStore;
}());
exports.SessionDataStore = SessionDataStore;
//# sourceMappingURL=session-data-store.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/state-manager/data-store/session-data-store.js
// module id = 524
// module chunks = 8